import { frontendOptions } from "../../../../../lib/systemData";
import GlobalTooltip from "../../../../common/GlobalTooltip";
import CheckboxCell from "../../../../common/interactive/CheckboxCell";
import CustomSelect from "../../../../common/interactive/CustomSelect";
import DatepickerWithLabel from "../../../../common/interactive/DatepickerWithLabel";
import InputBox from "../../../../common/interactive/InputBox";
import InputBoxCurrency from "../../../../common/interactive/InputBoxCurrency";
import Grid from "../../../../fragments/Grid";
import { formatDateLocal } from "../../../../../lib/script";
import AppointmentScheduledDate from "./AppointmentScheduledDate";
import { isCaseTypeWellness, searchTabInCaseType } from "../../../../../lib/misc";

export default function SurgicalTab7({classes, itemData, updateHandler, apiCase, activeCase}) {

    return <div className={classes.drawer_pannel}>
        <h3 className={classes.pannel_title}>#7 Surgery Appointments</h3>


        <Grid columns={2}>
            <div className={classes.drawer_column}>
                <div className={classes.drawer_row}>
                    {(searchTabInCaseType(activeCase, "major_med") || isCaseTypeWellness(activeCase)) && (
                        <div className={classes.drawer_row}>
                            <CheckboxCell 
                                label={'Surgical Authorization Obtained'} 
                                checked={itemData.step_7_surgical_auth_obtained} 
                                direction={'reverse'} 
                                identifier={{
                                    folder: 'surgeries',
                                    type: apiCase,
                                    field: 'step_7_surgical_auth_obtained',
                                    type_id: itemData.id
                                }}
                            />
                        </div>
                    )}
                    {/* className={`${classes.drawer_flex_block} ${classes.drawer_flex_block_equal}`} */}
                    <div className={classes.drawer_row}>
                        {/* //scheduled  date pulls either from step 5 or 4 if there is no step 5 */}
                        {/* {itemData.step_4_different_performing_surgeon ? 
                            <div className="flex-container flex-container-tooltip">
                                <DatepickerWithLabel disabled={true} label={'Scheduled Date'} action={updateHandler} defaultDate={itemData.step_5_est_surgical_date ? itemData.step_5_est_surgical_date : itemData.step_4_est_surgical_date} identifier={{folder: 'surgeries', type: apiCase, field: 'step_5_est_surgical_date', type_id: itemData.id}}/>
                                <GlobalTooltip>
                                    Not editable, information retrieved from step #4
                                </GlobalTooltip>
                            </div> 
                            : 
                            <div className="flex-container">
                                <DatepickerWithLabel disabled={true} label={'Scheduled Date'} action={updateHandler} defaultDate={itemData.step_4_est_surgical_date} identifier={{folder: 'surgeries', type: apiCase, field: 'step_4_est_surgical_date', type_id: itemData.id}}/>
                                <GlobalTooltip>
                                    Not editable, information retrieved from step #5
                                </GlobalTooltip>
                            </div>
                        } */}

                        <AppointmentScheduledDate itemData={itemData} updateHandler={updateHandler} apiCase={apiCase}/>
                        
                    </div>     
                    <div className={classes.drawer_row}>
                        <div className="flex-container">
                            <div style={{flex: 1}}>
                            <DatepickerWithLabel label={'Performed Date'} action={updateHandler} defaultDate={itemData.step_7_performed_date} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_performed_date', type_id: itemData.id}}/>    
                            </div>
                            <GlobalTooltip>
                                Can be automatically populated whenever the NG Order is marked as completed
                            </GlobalTooltip>
                        </div>
                    </div>      
                    <div className={classes.drawer_row}>
                        <div className="flex-container flex-container-tooltip">
                            <InputBox label={'Performed by'} action={updateHandler} currentValue={itemData.step_7_perfomed_by} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_perfomed_by', type_id: itemData.id}}/>
                            <GlobalTooltip>
                                Can be automatically populated whenever the NG Order is marked as completed
                            </GlobalTooltip>
                        </div>
                    </div> 
                    <div className={classes.drawer_row}>
                        <CustomSelect label={'Surgery Charges Status'} optionsData={frontendOptions()?.surgeryChargedStatus} preSelectedValue={itemData.step_7_charged_status} action={updateHandler} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_charged_status', type_id: itemData.id}}/>
                    </div>
                    {itemData.step_7_charged_status_date && <div className={classes.drawer_row}>
                        Last updated: {formatDateLocal(itemData.step_7_charged_status_date)}
                    </div>}
                    <div className={classes.drawer_row}>
                        <CheckboxCell label={'Implants Used'} action={updateHandler} checked={itemData.step_7_implants_used} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_implants_used', type_id: itemData.id}}/>
                    </div>
                    <div className={classes.drawer_row}>
                        <CheckboxCell label={'DME Given'} action={updateHandler} checked={itemData.step_7_dme_given} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_dme_given', type_id: itemData.id}}/>
                    </div>
                </div>  
            </div>

            <div className={classes.drawer_column}>
                <div className={classes.drawer_row}>
                    <div className='flex-container'>
                        <CheckboxCell label={'Pre-Op Call (at least 5 days before)'} action={updateHandler} checked={itemData.step_7_pre_op_cal} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_pre_op_cal', type_id: itemData.id}}/>
                        <InputBox label={'Name'} action={updateHandler} currentValue={itemData.step_7_pre_op_cal_name} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_pre_op_cal_name', type_id: itemData.id}}/>
                    </div>
                </div>
                <div className={classes.drawer_row}>
                    <CheckboxCell label={'Driver Confirmation'} action={updateHandler} checked={itemData.step_7_driver_confirmation} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_driver_confirmation', type_id: itemData.id}}/>
                </div>
                <div className={classes.drawer_row}>
                    <div className='flex-container'>
                        <CheckboxCell label={'48-hours Appointment Confirmed'} action={updateHandler} checked={itemData.step_7_appt_confirmed} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_appt_confirmed', type_id: itemData.id}}/>
                        <InputBox label={'Name'} action={updateHandler} currentValue={itemData.step_7_appt_confirmed_name} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_appt_confirmed_name', type_id: itemData.id}}/>
                    </div>
                </div>
                
                <div className={classes.drawer_row}>
                    <CheckboxCell label={'Final Insurance Verified'} action={updateHandler} checked={itemData.step_7_final_ins_verified} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_final_ins_verified', type_id: itemData.id}}/>
                </div>
                <div className={classes.drawer_row}>
                    <CheckboxCell label={'Medication Provided'} action={updateHandler} checked={itemData.step_7_medication_provided} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_medication_provided', type_id: itemData.id}}/>
                </div>

                <div className={classes.drawer_row}>
                    <div className='flex-container'>
                        <CheckboxCell label={'Out Of Pocket'} action={updateHandler} checked={itemData.step_7_out_of_pocket} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_out_of_pocket', type_id: itemData.id}}/>
                        <CheckboxCell label={'Collected'} action={updateHandler} checked={itemData.step_7_out_of_pocket_collected} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_out_of_pocket_collected', type_id: itemData.id}}/>
                        <CheckboxCell label={'At Time of Surgery'} action={updateHandler} checked={itemData.step_7_out_of_pocket_at_time_of_surgery} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_out_of_pocket_at_time_of_surgery', type_id: itemData.id}}/>
                    </div>
                </div>
                {itemData.step_7_out_of_pocket ? <div className={classes.drawer_row}>
                    <InputBoxCurrency label={'Amount Collected'} action={updateHandler} currentValue={itemData.step_7_amount_collected} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_amount_collected', type_id: itemData.id}} fullBox={true} />
                </div> : ''}
            </div>
        </Grid>      
    </div>
}